{
  "eyebrow": "Velg abonnementet ditt",
  "title": "Abonnementet som passer slik teamet ditt jobber.",
  "sub": "30 dagers gratis prøveperiode på alle abonnement. Ingen kredittkort nødvendig. Avslutt når som helst.",
  "bill": {
    "month": "Månedlig",
    "year": "Årlig",
    "save": "Spar ~17%"
  },
  "fam": {
    "time": "Tid og drift",
    "project": "Prosjekt- og kostnadskontroll"
  },
  "compare": "Sammenlign alle funksjoner",
  "compareHide": "Skjul sammenligning",
  "included": "Inkludert",
  "select": "Velg {{plan}}",
  "selected": "Valgt",
  "recommended": "Mest populær",
  "pricePerMonth": "/ bruker / måned",
  "pricePerYear": "/ bruker / år",
  "base": "grunn / måned",
  "admins": "2 administratorer inkludert",
  "continueCta": "Fortsett med {{plan}}",
  "continuePick": "Velg et abonnement for å fortsette",
  "catalogError": "Priskatalog ikke tilgjengelig. Prøv igjen for å laste de nyeste prisene.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Samsvar og enkel registrering",
    "timeProBest": "Teamdrift",
    "projectBasicBest": "Prosjekt- og kostnadskontroll",
    "projectProBest": "Avansert prosjektstyring",
    "feat": {
      "timeBasic": {
        "timeTracking": "Tidsregistrering",
        "absencesHolidays": "Fravær og ferie",
        "transport": "Transportlogger",
        "workLocations": "Arbeidssteder og GPS",
        "mobileApp": "Mobilapp for feltarbeidere"
      },
      "timePro": {
        "everythingTime": "Alt fra Time Basic",
        "overtime": "Overtidsregistrering",
        "scheduling": "Vaktplanlegging",
        "documents": "Ansattdokumenter",
        "officeOps": "Kontorfunksjoner (aktivitetslogg, korrigeringer)",
        "addonsAvailable": "Tilgjengelige tillegg: prosjektsporing, VTT",
        "internalMessaging": "Intern meldingstjeneste (bedriftschat)"
      },
      "projectBasic": {
        "everythingTime": "Alt fra Time Basic",
        "projects": "Prosjekter med kostnadskontroll",
        "extras": "Ekstraarbeid og ekstramateriell",
        "subcontractors": "Administrasjon av underleverandører",
        "checkInOut": "Innsjekking / utsjekking av ansatte",
        "internalMessaging": "Intern meldingstjeneste (bedriftschat)"
      },
      "projectPro": {
        "everythingAll": "Alt fra Time Pro + Project Basic",
        "projectTransport": "Prosjektbasert transport",
        "fullSuite": "Komplett produktivitetspakke",
        "prioritySupport": "Prioritert support",
        "internalMessaging": "Intern meldingstjeneste (bedriftschat)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Sammenlign alle funksjoner",
    "subtitle": "Alt hvert abonnement inkluderer, side om side.",
    "cat": {
      "timeAttendance": "Tid & oppmøte",
      "projectCost": "Prosjekt & kostnadskontroll",
      "support": "Kundestøtte"
    },
    "val": {
      "upTo4": "Opptil 4",
      "unlimited": "Ubegrenset",
      "soon": "Snart",
      "optional": "Valgfritt",
      "years5": "5 år",
      "years10": "10 år"
    },
    "row": {
      "mobileDesktop": "Mobil- og skrivebordsapp",
      "gpsCheckin": "Innsjekk med ett trykk og GPS",
      "holidayAbsenceOvertime": "Ferie, fravær & overtid",
      "teamMembers": "Teammedlemmer",
      "workLocations": "Arbeidssteder",
      "registrationsPerMonth": "Registreringer / bruker / måned",
      "irregularMap": "Uregelmessig inn-/utsjekk på kart",
      "expenseManagement": "Utgiftsstyring",
      "employeeDocuments": "Ansattdokumenter",
      "openApi": "Åpent API",
      "navigation": "Navigasjon til arbeidssteder",
      "projectManagement": "Prosjektstyring (budsjett)",
      "subprojects": "Delprosjekter",
      "subcontractorManagement": "Underleverandørstyring",
      "extraWorkMaterials": "Ekstraarbeid & materialer",
      "transportProjects": "Transport knyttet til prosjekter",
      "fullSuite": "Full produktivitetssuite",
      "prioritySupport": "Prioritert støtte",
      "schedulingMessaging": "Planlegging · Meldinger · Varsler",
      "languages12": "Tilgjengelig på 12 språk",
      "manualTransport": "Manuell transportavstand",
      "reportsExcel": "Rapporter og Excel-eksport",
      "frontendLocations": "Steder opprettet av app-brukere",
      "checkInWork": "Check-in/out@work (Belgia)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Prosjektbeskrivelser og bilder",
      "dataStorage": "Datalagring"
    }
  }
}
